import React, { useEffect, useState } from 'react'
import 'react-phone-input-2/lib/style.css'
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Skeleton from '../../components/ui/Skeleton';
import Button from '../../components/ui/Button';

const CustomSplit = ({ handleSubmit, loading }: any) => {

    const hhMembers = useMakeRequest();
    const [membPercent, setMembPercent] = useState<any>({})
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
    }, [])

    useEffect(() => {
        if (hhMembers?.status) {
            if (hhMembers?.data?.data?.length > 0) {
                const membObj: any = {}
                hhMembers?.data?.data?.map((memb: any) => {
                    membObj[memb?.user?.uuid] = { chores: null, expenses: null }
                })
                setMembPercent(membObj)
            }
        }
    }, [hhMembers?.status])

    const handleAddPercentage = (percent: string, membId: string, type: string | 'chores' | 'expenses') => {
        if (/^\d*\.?\d*$/.test(percent)) {
            setMembPercent((prevState: any) => {
                return {
                    ...prevState,
                    [membId]: {
                        ...prevState[membId],
                        [type]: Number(percent) > 100 ? 100 : percent,
                    }
                };
            });
        } return
    }

    const onSubmit = () => {
        if (Object.values(membPercent)?.length > 0) {
            let totalChores = 0;
            let totalExpenses = 0;
            Object.values(membPercent)?.map((member: any) => {
                totalChores += Number(member?.chores || 0);
                totalExpenses += Number(member?.expenses || 0);
            })
            if ((totalChores < 100) || (totalExpenses < 100)) {
                setErrorMessage('The percentages in each column must total 100%.');
            } else if ((totalChores > 100) || (totalExpenses > 100)) {
                setErrorMessage('The percentages in each column must total 100%.');
            } else {
                setErrorMessage('');
                handleSubmit(membPercent)
            }
        }
    }

    return (
        <div>
            {
                hhMembers?.loading ?
                    Array.from({ length: 3 })?.map(() => (
                        <div className='member-name-area page-padding-x'>
                            <div className='member-name'>
                                <Skeleton className='skeleton-loader member-picture' style={{ width: '32px', height: '32px', borderRadius: '50px' }} />
                                <Skeleton className='skeleton-loader member-nm' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                            </div>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className="com-input-grp">
                                        <label className="form-label"><Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px', borderRadius: '2px' }} /></label>
                                        <div className='percent-input'>
                                            <Skeleton className='skeleton-loader form-label' style={{ width: '200px', height: '30px', borderRadius: '2px' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className="com-input-grp">
                                        <label className="form-label"><Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px', borderRadius: '2px' }} /></label>
                                        <div className='percent-input'>
                                            <Skeleton className='skeleton-loader form-label' style={{ width: '200px', height: '30px', borderRadius: '2px' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    hhMembers?.data?.data?.length > 0 ?
                        <>

                            {hhMembers?.data?.data?.map((memb: any, membIndex: any) => {

                                return (
                                    <>
                                        <div className='member-name-area page-padding-x' key={membIndex}>
                                            <div className='member-name'>
                                                <div className='member-picture'><img src={memb?.user?.profile_pic} alt="" /></div>
                                                <span className='member-nm'>{memb?.user?.name}</span>
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label">Percentage of Chores</label>
                                                        <div className='percent-input'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Enter Chores'
                                                                value={membPercent[memb?.user?.uuid]?.chores}
                                                                onInput={(e: any) => {
                                                                    handleAddPercentage(e?.target?.value, memb?.user?.uuid, 'chores')
                                                                }}
                                                            />
                                                            <span className='percent-input-label'>%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label">Percentage of Expenses</label>
                                                        <div className='percent-input'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Enter Expense'
                                                                value={membPercent[memb?.user?.uuid]?.expenses}
                                                                onInput={(e: any) => {
                                                                    handleAddPercentage(e?.target?.value, memb?.user?.uuid, 'expenses')
                                                                }}
                                                            />
                                                            <span className='percent-input-label'>%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                            }
                            <p className='valid-error ms-3'>{errorMessage}</p>
                        </>
                        : ''
            }
            <div className='page-padding-x py-4'>
                <Button className='com-btn' style={{ width: "100%" }} onClick={onSubmit} loading={loading}>Submit</Button>
            </div>
        </div>
    )
}

export default CustomSplit